module.exports = __webpack_public_path__ + "static/media/white-car.a3bf201b.svg";